import { render } from "./topBanner.vue?vue&type=template&id=4f74f385"
import script from "./topBanner.vue?vue&type=script&lang=js"
export * from "./topBanner.vue?vue&type=script&lang=js"

import "./topBanner.vue?vue&type=style&index=0&id=4f74f385&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__